import { Injectable, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import {
  QuproObservable, BaseUser, QuproServiceError, QuproList, CsiteSupplier, CsiteService,
  UserService, LocalStorageQuproLogger, LoginData, IssueSupplier, IssuesFilterSupplier,
  IssuesOrderSupplier, ProformasService, IssuesService, SupplierUser,
  ProformasFilter, ProformasOrder, Proforma, CsitesFilterSupplier, SupplierCsitesOrder, OperatorService,
  SupplierCsitesOrderType, MastersService, HousesService, House, DocumentReport, DownloadTypes, WorksheetReport, IssueUpdateDataSupplier,
  ProformaUpdateDataSupplier, ProformaCreateDataBase, SupplierCommentUpdateDataBase, AgreementService, SupplierAgreementUploaded,
  DocumentProformaReport, PhotoIssue, IssueUpdateResponse
} from '@arpada/arp-lib-common-qupro';
import { Observable, Subscription } from 'rxjs';
import { MessagesService } from './messages.service';
import { SupplierExtendedData } from './dto/supplier.extended.data';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PortalProveedorService {

  private readonly ODOO_URL: string;

  private operatorSelectedEvent = new EventEmitter();

  issuesPostsaleReceivedEvent = new EventEmitter();
  updateLineaProformaEvent = new EventEmitter();
  createProformaEvent = new EventEmitter();
  updateOperatorEvent = new EventEmitter();
  selectOperatorEvent = new EventEmitter();
  issuesReviewResetRowsSelectedEvent = new EventEmitter();
  issuesPostsaleResetRowsSelectedEvent = new EventEmitter();
  issuesProformablesRowsSelectedEvent = new EventEmitter();
  modoVistaEvent = new EventEmitter();
  getTituloEvent = new EventEmitter();
  edicionMasivaEvent = new EventEmitter();
  errorEdicionMasivaEvent = new EventEmitter();
  selectionCardEvent = new EventEmitter();
  selectionAllCardsEvent = new EventEmitter();

  constructor(
              private userService: UserService,
              public logger: LocalStorageQuproLogger,
              public csiteService: CsiteService,
              private proformasService: ProformasService,
              private issuesService: IssuesService,
              public mastersService: MastersService,
              public housesService: HousesService,
              public messagesService: MessagesService,
              private router: Router,
              private operatorService: OperatorService,
              private agreementService: AgreementService
              ) { }

  public getSupplierDataCached(): Observable<SupplierExtendedData> {
    const toReturn: QuproObservable<SupplierExtendedData> = new QuproObservable<SupplierExtendedData>();
    const supplierExtendedData: SupplierExtendedData = new SupplierExtendedData();
    const completeTimeoutForMemoryLeaks = 10000;
    this.userService.getLoggedUserDataCached()
    .subscribe((supplier: SupplierUser) => {
      supplierExtendedData.supplier = supplier;
      toReturn.next(supplierExtendedData);
      toReturn.completeTimeout(completeTimeoutForMemoryLeaks);
    },
    (error: QuproServiceError) => {
      toReturn.error(error);
      toReturn.completeTimeout(completeTimeoutForMemoryLeaks);
    });
    return toReturn;
  }

  public getSupplierData(): Observable<SupplierUser> {
    return this.userService.getLoggedUserDataCached<SupplierUser>();
  }

  public loginUsuario(loginUser: string, password: string): Observable<LoginData> {
    return this.userService.loginUsuario(loginUser, password);
  }

  public cerrarSesion() {
    this.unsetOperator();
    this.userService.cerrarSesion();
    this.router.navigate(['/login'], { replaceUrl: true });
  }

  public changePassword(newPassword: string): Observable<string> {
    return this.userService.changePassword(newPassword);
  }

  public loginAfterChangePassword(password: string): Observable<LoginData> {
    const username = this.userService.getLoggedUserName();
    if (username) {
        return this.userService.loginUsuario(username, password);
    } else {
        throw new Error(this.messagesService.getLoginErrorAfterChangePasswordEmptyUsername());
    }
  }

  public isUserLogin(errorCallback: (error: Error) => void, quproErrorCallback: (error: QuproServiceError) => void): Promise<boolean> {
        return this.userService.isUserLogin(errorCallback, quproErrorCallback);
  }

  public isUserLoggedLocal() {
    return this.userService.isUserLoggedLocal();
  }

  public resetPassword(loginUser: string, resetPasswordUrl: string): Observable<object> {
    return this.userService.resetPassword(loginUser, resetPasswordUrl);
  }

  public getCsitesOfSupplier(filter: CsitesFilterSupplier): Observable<QuproList<CsiteSupplier>> {
    let hasResponse = false;
    const toReturn = new QuproObservable<QuproList<CsiteSupplier>>();
    const completeTimeoutForMemoryLeaks = 30000;
    const order: SupplierCsitesOrder = new SupplierCsitesOrder(SupplierCsitesOrderType.DEFAULT_ORDER);
    this.userService.getLoggedUserDataCached().subscribe((user: BaseUser) => {
      filter.supplier_partner_id = user.partner_id;
      this.csiteService.getSupplierCsites(filter, order, 0, 0).subscribe((csitesList: QuproList<CsiteSupplier>) => {
        hasResponse = true;
        toReturn.next(csitesList);
        toReturn.completeTimeout(completeTimeoutForMemoryLeaks);
      }, (quproError: QuproServiceError) => {
        hasResponse = true;
        toReturn.error(quproError);
        toReturn.completeTimeout(completeTimeoutForMemoryLeaks);
      });
    }, (quproError: QuproServiceError) => {
      hasResponse = true;
      toReturn.error(quproError);
      toReturn.completeTimeout(completeTimeoutForMemoryLeaks);
    }, () => {
      if (!hasResponse) {
          toReturn.completeTimeout(completeTimeoutForMemoryLeaks);
      }
    });
    return toReturn;
  }

  public getCsiteOfSupplierByCsiteId(csiteId: number, mode?: string): Observable<QuproList<CsiteSupplier>> {
    let hasResponse = false;
    const toReturn = new QuproObservable<QuproList<CsiteSupplier>>();
    const completeTimeoutForMemoryLeaks = 30000;
    const filter: CsitesFilterSupplier = new CsitesFilterSupplier();
    filter.id = csiteId;
    const order: SupplierCsitesOrder = new SupplierCsitesOrder(SupplierCsitesOrderType.DEFAULT_ORDER);
    this.userService.getLoggedUserDataCached().subscribe((user: BaseUser) => {
      filter.supplier_partner_id = user.partner_id;
      this.csiteService.getSupplierCsites(filter, order, 0, 0, mode).subscribe((csitesList: QuproList<CsiteSupplier>) => {
        hasResponse = true;
        toReturn.next(csitesList);
        toReturn.completeTimeout(completeTimeoutForMemoryLeaks);
      }, (quproError: QuproServiceError) => {
        hasResponse = true;
        toReturn.error(quproError);
        toReturn.completeTimeout(completeTimeoutForMemoryLeaks);
      });
    }, (quproError: QuproServiceError) => {
      hasResponse = true;
      toReturn.error(quproError);
      toReturn.completeTimeout(completeTimeoutForMemoryLeaks);
    }, () => {
      if (!hasResponse) {
          toReturn.completeTimeout(completeTimeoutForMemoryLeaks);
      }
    });
    return toReturn;
  }

  public getSupplierCsitesCached(operatorSel: number, mode?: string): Observable<QuproList<CsiteSupplier>> {
    let hasResponse = false;
    const toReturn = new QuproObservable<QuproList<CsiteSupplier>>();
    const completeTimeoutForMemoryLeaks = 30000;
    const filter: CsitesFilterSupplier = new CsitesFilterSupplier();
    filter.operator_num = operatorSel;
    const order: SupplierCsitesOrder = new SupplierCsitesOrder(SupplierCsitesOrderType.DEFAULT_ORDER);
    this.userService.getLoggedUserDataCached().subscribe((user: BaseUser) => {
      filter.supplier_partner_id = user.partner_id;
      this.csiteService.getSupplierCsitesCached(filter, order, 0, 0, mode).subscribe((csitesList: QuproList<CsiteSupplier>) => {
        hasResponse = true;
        toReturn.next(csitesList);
        toReturn.completeTimeout(completeTimeoutForMemoryLeaks);
      }, (quproError: QuproServiceError) => {
        hasResponse = true;
        toReturn.error(quproError);
        toReturn.completeTimeout(completeTimeoutForMemoryLeaks);
      });
    }, (quproError: QuproServiceError) => {
      hasResponse = true;
      toReturn.error(quproError);
      toReturn.completeTimeout(completeTimeoutForMemoryLeaks);
    }, () => {
      if (!hasResponse) {
          toReturn.completeTimeout(completeTimeoutForMemoryLeaks);
      }
    });
    return toReturn;
  }

  public getPostSaleIssuesFromCsiteSupplier(csiteId: string, filter: IssuesFilterSupplier, order: IssuesOrderSupplier,
                                            start: number, limit: number): Observable<QuproList<IssueSupplier>> {
    let hasResponse = false;
    const toReturn = new QuproObservable<QuproList<IssueSupplier>>();
    const completeTimeoutForMemoryLeaks = 30000;
    if (csiteId !== 'all') {
      filter.csite_id = +csiteId;
    }
    filter.phase = 'postsale';
    this.userService.getLoggedUserDataCached().subscribe((user: BaseUser) => {
      filter.supplier_partner_id = user.partner_id;
      this.issuesService.getIssuesSupplier(filter, order, start, limit)
        .subscribe((issuesPostSaleList: QuproList<IssueSupplier>) => {
          hasResponse = true;
          toReturn.next(issuesPostSaleList);
          toReturn.completeTimeout(completeTimeoutForMemoryLeaks);
        }, (quproError: QuproServiceError) => {
          hasResponse = true;
          toReturn.error(quproError);
          toReturn.completeTimeout(completeTimeoutForMemoryLeaks);
        });
    }, (quproError: QuproServiceError) => {
      hasResponse = true;
      toReturn.error(quproError);
      toReturn.completeTimeout(completeTimeoutForMemoryLeaks);
    }, () => {
      if (!hasResponse) {
          toReturn.completeTimeout(completeTimeoutForMemoryLeaks);
      }
    });
    return toReturn;
  }

  public getProformasSupplier(filter: ProformasFilter, order: ProformasOrder,
                              start: number, limit: number): Observable<QuproList<Proforma>> {
    let hasResponse = false;
    const completeTimeoutForMemoryLeaks = 30000;
    const toReturn = new  QuproObservable<QuproList<Proforma>>();
    this.userService.getLoggedUserDataCached().subscribe((user: BaseUser) => {
      filter.supplier_partner_id = user.partner_id;
      this.proformasService.getProformas(filter, order, start, limit).subscribe((proformasList: QuproList<Proforma>) => {
        hasResponse = true;
        toReturn.next(proformasList);
        toReturn.completeTimeout(completeTimeoutForMemoryLeaks);
      });
    }, (quproError: QuproServiceError) => {
      hasResponse = true;
      toReturn.error(quproError);
      toReturn.completeTimeout(completeTimeoutForMemoryLeaks);
    }, () => {
      if (!hasResponse) {
        toReturn.completeTimeout(completeTimeoutForMemoryLeaks);
      }
    });
    return toReturn;
  }

  public getProformasSupplierCached(filter: ProformasFilter, order: ProformasOrder,
                                    start: number, limit: number): Observable<QuproList<Proforma>> {
    let hasResponse = false;
    const completeTimeoutForMemoryLeaks = 30000;
    const toReturn = new  QuproObservable<QuproList<Proforma>>();
    this.userService.getLoggedUserDataCached().subscribe((user: BaseUser) => {
    filter.supplier_partner_id = user.partner_id;
    this.proformasService.getProformasCached(filter, order, start, limit).subscribe((proformasList: QuproList<Proforma>) => {
    hasResponse = true;
    toReturn.next(proformasList);
    toReturn.completeTimeout(completeTimeoutForMemoryLeaks);
    });
    }, (quproError: QuproServiceError) => {
    hasResponse = true;
    toReturn.error(quproError);
    toReturn.completeTimeout(completeTimeoutForMemoryLeaks);
    }, () => {
    if (!hasResponse) {
    toReturn.completeTimeout(completeTimeoutForMemoryLeaks);
    }
    });
    return toReturn;
  }

  public updateProforma(proformaToUpdate: ProformaUpdateDataSupplier): Observable<string> {
    return this.proformasService.editarProforma(proformaToUpdate);
  }

  public createProforma(proformaCreateDataBase: ProformaCreateDataBase): Observable<number[]> {
    return this.proformasService.crearProforma(proformaCreateDataBase);
  }

  public updateIssuesOperator(issuesToEdit: IssueSupplier[], issueUpdateDataSupplier: IssueUpdateDataSupplier): Observable<string> {
    let resp: Observable<string> = new Observable<string>();
    issuesToEdit.forEach(issueToEdit => {
      resp = this.issuesService.updateIssue(issueToEdit.id, issueUpdateDataSupplier);
    });
    return resp;
  }

  public updateIssue(id: number, issue: IssueUpdateDataSupplier): Observable<string> {
    let resp: Observable<string> = new Observable<string>();
    resp = this.issuesService.updateIssue(id, issue);
    return resp;
  }

  public doSupplierComment(commentsToUpdate: SupplierCommentUpdateDataBase[]): Observable<number[]> {
    return this.issuesService.doSupplierComment(commentsToUpdate);

  }

  public marksAsPendingMaterial(issuesIds: number[]): Observable<number[]> {
    return this.issuesService.markAsPendingMaterial(issuesIds);
  }

  public getReviewPresaleIssuesFromSupplier(filter: IssuesFilterSupplier, order: IssuesOrderSupplier,
                                            start: number, limit: number): QuproObservable<QuproList<IssueSupplier>> {
    let hasResponse = false;
    const toReturn = new QuproObservable<QuproList<IssueSupplier>>();
    const completeTimeoutForMemoryLeaks = 30000;

    this.userService.getLoggedUserDataCached().subscribe((user: BaseUser) => {
      filter.supplier_partner_id = user.partner_id;
      this.issuesService.getReviewPresaleIssuesSupplier(filter, order, start, limit)
        .subscribe((presaleIssueList: QuproList<IssueSupplier>) => {
          hasResponse = true;
          toReturn.next(presaleIssueList);
          toReturn.completeTimeout(completeTimeoutForMemoryLeaks);
        }, (quproError: QuproServiceError) => {
          hasResponse = true;
          toReturn.error(quproError);
          toReturn.completeTimeout(completeTimeoutForMemoryLeaks);
        });
    }, (quproError: QuproServiceError) => {
      hasResponse = true;
      toReturn.error(quproError);
      toReturn.completeTimeout(completeTimeoutForMemoryLeaks);
    }, () => {
      if (!hasResponse) {
          toReturn.completeTimeout(completeTimeoutForMemoryLeaks);
      }
    });
    return toReturn;
  }

  public getIssuesProformablesFromCsiteSupplier(filter: IssuesFilterSupplier, order: IssuesOrderSupplier,
                                                start: number, limit: number): Observable<QuproList<IssueSupplier>> {
    let hasResponse = false;
    const toReturn = new QuproObservable<QuproList<IssueSupplier>>();
    const completeTimeoutForMemoryLeaks = 30000;  
    // filter.phase = 'postsale';
    filter.setPhaseKeys(['postsale', 'mantenimiento'])
    filter.proformable = 1;
    filter.filter_conform_supplier = 1;
    this.userService.getLoggedUserDataCached().subscribe((user: BaseUser) => {
      filter.supplier_partner_id = user.partner_id;
      this.issuesService.getIssuesSupplier(filter, order, start, limit)
        .subscribe((issuesPostSaleList: QuproList<IssueSupplier>) => {
          hasResponse = true;
          toReturn.next(issuesPostSaleList);
          toReturn.completeTimeout(completeTimeoutForMemoryLeaks);
        }, (quproError: QuproServiceError) => {
          hasResponse = true;
          toReturn.error(quproError);
          toReturn.completeTimeout(completeTimeoutForMemoryLeaks);
        });
      }, (quproError: QuproServiceError) => {
        hasResponse = true;
        toReturn.error(quproError);
        toReturn.completeTimeout(completeTimeoutForMemoryLeaks);
      }, () => {
        if (!hasResponse) {
        toReturn.completeTimeout(completeTimeoutForMemoryLeaks);
        }
      });
    return toReturn;
  }

  public getCachedJobs() {
    return this.mastersService.getCachedJobs();
  }

  public getCachedLocations(csiteId: number, commonArea: number) {
    return this.mastersService.getCachedLocalizations(csiteId, commonArea);
  }

  public getCachedHouses(csiteId: number, commonArea: boolean): Observable<QuproList<House>> {
    return this.housesService.getSupplierHousesCached(csiteId, commonArea);
  }

  public downloadWorksheet(worksheetReport: WorksheetReport, downloadType: DownloadTypes): QuproObservable<DocumentReport> {
    return this.issuesService.downloadWorksheet(worksheetReport, downloadType);
  }

  public downloadProformas(proformasIds: number[]): QuproObservable<DocumentProformaReport> {
    return this.proformasService.downloadProformasSelected(proformasIds);
  }

  public markAsRepaired(issuesIds: number[]): Observable<IssueUpdateResponse> {
    return this.issuesService.markAsRepaired(issuesIds);
  }

  public getOperarios(): Observable<QuproList<number>> {
    let hasResponse = false;
    const toReturn = new QuproObservable<QuproList<number>>();
    const completeTimeoutForMemoryLeaks = 30000;
    this.userService.getLoggedUserDataCached().subscribe((user: BaseUser) => {
      const supplierPartnerId = user.partner_id;
      this.operatorService.getOperators(supplierPartnerId)
        .subscribe((operators: QuproList<number>) => {
          hasResponse = true;
          toReturn.next(operators);
          toReturn.completeTimeout(completeTimeoutForMemoryLeaks);
        }, (quproError: QuproServiceError) => {
          hasResponse = true;
          toReturn.error(quproError);
          toReturn.completeTimeout(completeTimeoutForMemoryLeaks);
        });
    }, (quproError: QuproServiceError) => {
      hasResponse = true;
      toReturn.error(quproError);
      toReturn.completeTimeout(completeTimeoutForMemoryLeaks);
    }, () => {
      if (!hasResponse) {
          toReturn.completeTimeout(completeTimeoutForMemoryLeaks);
      }
    });
    return toReturn;
  }

  public getOperariosWithSupplierNumber(supplierPartnerId: number): Observable<QuproList<number>> {
    let hasResponse = false;
    const toReturn = new QuproObservable<QuproList<number>>();
    const completeTimeoutForMemoryLeaks = 30000;
    this.operatorService.getOperators(supplierPartnerId).subscribe((operators: QuproList<number>) => {
      hasResponse = true;
      toReturn.next(operators);
      toReturn.completeTimeout(completeTimeoutForMemoryLeaks);
    }, (quproError: QuproServiceError) => {
      hasResponse = true;
      toReturn.error(quproError);
      toReturn.completeTimeout(completeTimeoutForMemoryLeaks);
    });
    return toReturn;
  }

  public getOperatorSel(): number {
    let operatorId: number;
    const operatorSeleccionado = JSON.parse(localStorage.getItem('operadorSeleccionado'));
    if (operatorSeleccionado) {
      operatorId = operatorSeleccionado;
    }
    return operatorId;
  }

  public setOperatorSel(operatorId: number) {
    localStorage.setItem('operadorSeleccionado', JSON.stringify(operatorId));
    this.getSupplierCsitesCached(operatorId).subscribe(resp => {
      this.operatorSelectedEvent.emit(operatorId);
    });
  }

  public unsetOperator() {
    localStorage.removeItem('operadorSeleccionado');
    this.operatorSelectedEvent.emit();
  }

  public onChangeOperatorSelected(subscribe: (operatorSel: number) => void): Subscription {
    return this.operatorSelectedEvent.subscribe(subscribe);
  }

  public secureResetPassword(loginUser: string, resetPasswordUrl: string, captchaResponseToken: string): Observable<object> {
    const captchaAlias: string = environment.recaptchaApiKeyAlias;
    return this.userService.secureResetPassword(loginUser, resetPasswordUrl, captchaAlias, captchaResponseToken);
  }

  public supplierAgreement(signatureName: string, signatureVat: string, issuesIds: number[], base64: string, mimetype: string)
    : Observable<SupplierAgreementUploaded> {
      return this.agreementService.uploadSupplierAgreement(signatureName, signatureVat, issuesIds, base64, mimetype);
  }

  public getPhotoIssue(issueId: number): Observable<QuproList<PhotoIssue>> {
    const width = 495;
    const height = 495;
    let hasResponse = false;
    const toReturn = new QuproObservable<QuproList<PhotoIssue>>();
    const completeTimeoutForMemoryLeaks = 30000;
    this.issuesService.getPhotoIssue(issueId, width, height).subscribe((photoIssues: QuproList<PhotoIssue>) => {
      hasResponse = true;
      toReturn.next(photoIssues);
      toReturn.completeTimeout(completeTimeoutForMemoryLeaks);
    }, (quproError: QuproServiceError) => {
      hasResponse = true;
      toReturn.error(quproError);
      toReturn.completeTimeout(completeTimeoutForMemoryLeaks);
    });
    return toReturn;
  }

  public getSupplierCsitesComboPostsale(filter: CsitesFilterSupplier): Observable<QuproList<CsiteSupplier>> {
    let hasResponse = false;
    const toReturn = new QuproObservable<QuproList<CsiteSupplier>>();
    const completeTimeoutForMemoryLeaks = 30000;
    const order: SupplierCsitesOrder = new SupplierCsitesOrder(SupplierCsitesOrderType.DEFAULT_ORDER);
    this.userService.getLoggedUserDataCached().subscribe((user: BaseUser) => {
      filter.supplier_partner_id = user.partner_id;
      this.csiteService.getSupplierCsitesComboPostsale(filter, order, 0, 0).subscribe((csitesList: QuproList<CsiteSupplier>) => {
        hasResponse = true;
        toReturn.next(csitesList);
        toReturn.completeTimeout(completeTimeoutForMemoryLeaks);
      }, (quproError: QuproServiceError) => {
        hasResponse = true;
        toReturn.error(quproError);
        toReturn.completeTimeout(completeTimeoutForMemoryLeaks);
      });
    }, (quproError: QuproServiceError) => {
      hasResponse = true;
      toReturn.error(quproError);
      toReturn.completeTimeout(completeTimeoutForMemoryLeaks);
    }, () => {
      if (!hasResponse) {
          toReturn.completeTimeout(completeTimeoutForMemoryLeaks);
      }
    });
    return toReturn;
  }

  public getSupplierCsitesComboByMode(filter: CsitesFilterSupplier, mode: string): Observable<QuproList<CsiteSupplier>> {
    let hasResponse = false;
    const toReturn = new QuproObservable<QuproList<CsiteSupplier>>();
    const completeTimeoutForMemoryLeaks = 30000;
    const order: SupplierCsitesOrder = new SupplierCsitesOrder(SupplierCsitesOrderType.DEFAULT_ORDER);
    this.userService.getLoggedUserDataCached().subscribe((user: BaseUser) => {
      filter.supplier_partner_id = user.partner_id;
      
      this.csiteService.getSupplierCsitesComboByMode(filter, mode, order, 0, 0).subscribe((csitesList: QuproList<CsiteSupplier>) => {
        hasResponse = true;
        toReturn.next(csitesList);
        toReturn.completeTimeout(completeTimeoutForMemoryLeaks);
      }, (quproError: QuproServiceError) => {
        hasResponse = true;
        toReturn.error(quproError);
        toReturn.completeTimeout(completeTimeoutForMemoryLeaks);
      });
    }, (quproError: QuproServiceError) => {
      hasResponse = true;
      toReturn.error(quproError);
      toReturn.completeTimeout(completeTimeoutForMemoryLeaks);
    }, () => {
      if (!hasResponse) {
          toReturn.completeTimeout(completeTimeoutForMemoryLeaks);
      }
    });
    return toReturn;
  }

  public getSupplierCsitesComboReviewPresale(filter: CsitesFilterSupplier): Observable<QuproList<CsiteSupplier>> {
    let hasResponse = false;
    const toReturn = new QuproObservable<QuproList<CsiteSupplier>>();
    const completeTimeoutForMemoryLeaks = 30000;
    const order: SupplierCsitesOrder = new SupplierCsitesOrder(SupplierCsitesOrderType.DEFAULT_ORDER);
    this.userService.getLoggedUserDataCached().subscribe((user: BaseUser) => {
      filter.supplier_partner_id = user.partner_id;
      this.csiteService.getSupplierCsitesComboReviewPresale(filter, order, 0, 0).subscribe((csitesList: QuproList<CsiteSupplier>) => {
        hasResponse = true;
        toReturn.next(csitesList);
        toReturn.completeTimeout(completeTimeoutForMemoryLeaks);
      }, (quproError: QuproServiceError) => {
        hasResponse = true;
        toReturn.error(quproError);
        toReturn.completeTimeout(completeTimeoutForMemoryLeaks);
      });
    }, (quproError: QuproServiceError) => {
      hasResponse = true;
      toReturn.error(quproError);
      toReturn.completeTimeout(completeTimeoutForMemoryLeaks);
    }, () => {
      if (!hasResponse) {
          toReturn.completeTimeout(completeTimeoutForMemoryLeaks);
      }
    });
    return toReturn;
  }

  public getMantenimientoIssuesFromCsiteSupplier(filter: IssuesFilterSupplier, order: IssuesOrderSupplier,
    start: number, limit: number): QuproObservable<QuproList<IssueSupplier>> {
      let hasResponse = false;
      const toReturn = new QuproObservable<QuproList<IssueSupplier>>();
      const completeTimeoutForMemoryLeaks = 30000;
      filter.phase = 'mantenimiento';
      this.userService.getLoggedUserDataCached().subscribe((user: BaseUser) => {
        filter.supplier_partner_id = user.partner_id;
        this.issuesService.getIssuesSupplier(filter, order, start, limit)
        .subscribe((mantenimientoIssueList: QuproList<IssueSupplier>) => {
          hasResponse = true;
          toReturn.next(mantenimientoIssueList);
          toReturn.completeTimeout(completeTimeoutForMemoryLeaks);
        }, (quproError: QuproServiceError) => {
          hasResponse = true;
          toReturn.error(quproError);
          toReturn.completeTimeout(completeTimeoutForMemoryLeaks);
        });
      }, (quproError: QuproServiceError) => {
          hasResponse = true;
          toReturn.error(quproError);
          toReturn.completeTimeout(completeTimeoutForMemoryLeaks);
      }, () => {
        if (!hasResponse) {
          toReturn.completeTimeout(completeTimeoutForMemoryLeaks);
        }
      });
      return toReturn;
}

}
